<template>
  <v-popover offset="11"
             :open="openPopover"
             trigger="manual"
             open-group="user-role-popover"
             popoverClass="user-role-popover"
             @hide="cancel">
    <BaseSelect v-model="newUserRole"
                :options="rolesList"
                label="name"
                class="role-select"
                :searchable="false"
                :allow-empty="false"
                size="sm"
                @select="handleSelect"/>
    <template slot="popover">
      <div class="col-span-2">
        <div class="text-lg font-bold text-text">
          {{ $t('changeRole') }}
        </div>
        <p class="mb-4 text-text text-2sm text-center">
          {{ changeRoleText }}
        </p>
      </div>
      <div class="actions">
        <BaseButton theme="red"
                    size="sm"
                    :loading="submitted"
                    @click.native="apply">
          {{ $t('apply') }}
        </BaseButton>
        <BaseButton theme="white-red"
                    size="sm"
                    :loading="submitted"
                    v-close-popover
                    @click.native="cancel">
          {{ $t('cancel') }}
        </BaseButton>
      </div>
    </template>
  </v-popover>
</template>

<script>
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import BaseButton from "@/components/UI/BaseButton";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "ChangeUserRole",
  components: {BaseButton, BaseSelect},
  data() {
    return {
      newUserRole: this.role,
      openPopover: false,
      submitted: false
    }
  },
  props: {
    role: {
      type: Object
    },
    userId: {
      type: Number
    },
    rolesList: {
      type: Array
    }
  },
  computed: {
    changeRoleText() {
      return this.$t(`roleText${this.newUserRole.id}`)
    }
  },
  methods: {
    ...mapActions('space/access', ['updateUserRole']),
    ...mapMutations('space/access', ['setUserRole']),
    handleSelect(newRole) {
      if (this.role.id == newRole.id) return;
      this.openPopover = true;
    },
    async apply() {
      try {
        this.submitted = true;
        let data = {
          user_id: this.userId,
          role: +this.newUserRole.id
        }
        const res = await this.updateUserRole(data);
        if (res.body.success) {
          this.setUserRole(data);
          this.$emit('applyRole')
          this.$toasted.success('Успешно')
        } else {
          console.log(res)
          this.$toasted.error('Ошибка')
        }
      } catch (err) {
        console.error(err)
        this.$toasted.error('Ошибка')
      } finally {
        this.submitted = false;
        this.openPopover = false;
      }
    },
    cancel() {
      this.newUserRole = this.role;
      this.openPopover = false;
    }
  },
  watch: {
    role: {
      handler(newVal) {
        this.newUserRole = newVal;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        changeRole: 'Changing role',
        roleText0: 'The viewer will only be able to see your data. Do you agree?',
        roleText1: 'The user cannot delete the workspace or invite members. Do you agree?',
        roleText2: 'The administrator will be able to delete this workspace and invite other members. Do you agree?',
        apply: 'Yes',
        cancel: 'No, change role'
      },
      ru: {
        changeRole: 'Изменить роль',
        roleText0: 'Наблюдатель сможет только посмотреть ваши данные. Вы согласны?',
        roleText1: 'Пользователь не может удалить пространство и приглашать участников. Вы согласны?',
        roleText2: 'Администратор сможет удалить пространство и пригласить других участников. Вы согласны?',
        apply: 'Да',
        cancel: 'Нет, изменить роль'
      }
    }
  }
}
</script>

<style lang="scss">
.v-popover {
  .role-select {
    width: 173px;
  }
}

.user-role-popover.tooltip.popover {
  .popover-inner {
    padding: 12px;
    max-width: 29rem;

    .actions {
      @apply grid col-gap-4;
      grid-template-columns: 37.6% 1fr;
    }
  }
}
</style>